/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceStatItem
 */
export interface SurfaceStatItem {
    /**
     * 
     * @type {string}
     * @memberof SurfaceStatItem
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStatItem
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStatItem
     */
    prefix?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceStatItem
     */
    suffix?: string;
}

/**
 * Check if a given object implements the SurfaceStatItem interface.
 */
export function instanceOfSurfaceStatItem(value: object): value is SurfaceStatItem {
    return true;
}

export function SurfaceStatItemFromJSON(json: any): SurfaceStatItem {
    return SurfaceStatItemFromJSONTyped(json, false);
}

export function SurfaceStatItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStatItem {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'label': json['label'] == null ? undefined : json['label'],
        'prefix': json['prefix'] == null ? undefined : json['prefix'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
    };
}

export function SurfaceStatItemToJSON(json: any): SurfaceStatItem {
    return SurfaceStatItemToJSONTyped(json, false);
}

export function SurfaceStatItemToJSONTyped(value?: SurfaceStatItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
        'prefix': value['prefix'],
        'suffix': value['suffix'],
    };
}

